/**
 * Represents the list of Brazilian tax regimes.
 * @typedef {Object} TaxRegime
 * @property {string} id - The ID of the tax regime.
 * @property {string} name - The name of the tax regime.
 */

/**
 * List of Brazilian tax regimes.
 * @type {TaxRegime[]}
 */
export default [
  { id: 'Isento', name: 'Isento' },
  { id: 'MicroempreendedorIndividual', name: 'Micro empreendedor individual' },
  { id: 'SimplesNacional', name: 'Simples nacional' },
  { id: 'LucroPresumido', name: 'Lucro presumido' },
  { id: 'LucroReal', name: 'Lucro real' }
]
